const { VITE_ANALYSIS_AGENT_API } = import.meta.env;

// DAG-trigger toolkits analysis-agent mounts a run-status route for
// (`build_run_status_router` in `routers/v1/airflow_run_status.py`).
export const PUBLIC_DATASET_TOOLKIT_ID = "public_dataset_trigger";
export const VCF_INGEST_TOOLKIT_ID = "vcf_ingest_trigger";
export type DagTriggerToolkit = typeof PUBLIC_DATASET_TOOLKIT_ID | typeof VCF_INGEST_TOOLKIT_ID;

export const runStatusPath = (toolkit: DagTriggerToolkit, dagId: string, runId: string) =>
  `${VITE_ANALYSIS_AGENT_API}/dag-runs/${toolkit}/${encodeURIComponent(dagId)}/${encodeURIComponent(runId)}/status`;

// A TaskInstance's `state` vocabulary — larger than a DagRun's own `state`.
// Mirrors `agent_utils.clients.airflow_client.TaskInstanceState`. `null` (no
// state yet) is distinct from the literal string `"none"` (a deprecated but
// real Airflow state).
export type TaskInstanceState =
  | "none"
  | "scheduled"
  | "queued"
  | "running"
  | "success"
  | "restarting"
  | "failed"
  | "up_for_retry"
  | "up_for_reschedule"
  | "upstream_failed"
  | "skipped"
  | "removed"
  | "deferred";

// One task instance within a run. `mapIndex` is `-1` for a normal task, or
// `>= 0` for one instance of a dynamically-mapped task (Airflow's `.expand()`)
// — several instances then share one `taskId`.
export interface TaskInstanceStatus {
  taskId: string;
  mapIndex: number;
  state: TaskInstanceState | null;
  startDate: string | null;
  endDate: string | null;
  duration: number | null;
  tryNumber: number;
}

export const AirflowRunState = {
  QUEUED: "queued",
  RUNNING: "running",
  SUCCESS: "success",
  FAILED: "failed",
} as const;
export type AirflowRunState = (typeof AirflowRunState)[keyof typeof AirflowRunState];

// succeeded/failed are terminal and never change again; queued/running are
// still in flight. A run that reaches a terminal state stops polling.
export const AIRFLOW_RUN_TERMINAL_STATES: ReadonlySet<string> = new Set([
  AirflowRunState.SUCCESS,
  AirflowRunState.FAILED,
]);

export interface DagRunStatus {
  dagId: string;
  runId: string;
  state: AirflowRunState;
  logicalDate: string | null;
  startDate: string | null;
  endDate: string | null;
  tasks: TaskInstanceStatus[];
}
